import {
  EnviromentZone, HowdenLoginBehaviour, HowdenLoginKind, IHowdenEnvironment, LogLevel, TENANT_TYPES
} from '@howdeniberia/core-front';

export const environment = {
  zone: EnviromentZone.DEVELOPMENT,
  appIdSecurity: 7, //Es necesario establecer el Id de la aplicación asignado en Howden Security
  loginBehaviour: HowdenLoginBehaviour.REDIRECT,
  howdenLoginUrl: 'https://how-login.app-dev.howdeniberia.com',
  loginKind: HowdenLoginKind.INTERNAL,
  fixedTenant: TENANT_TYPES.singular,
  logLevel: LogLevel.INFO
} as IHowdenEnvironment;
